// extracted by mini-css-extract-plugin
module.exports = {"collections-metadata-settings":"metadata_collections-metadata-settings__jtJ8u","collection-date-picker":"metadata_collection-date-picker__10cNL"};